import Archivos from '../componentes/index.vue'

const routes = [
    /*...route('/guardar-protocolo', FormProtocolo, {
        Auth: true,
        ///req_admin: true
     }),*/
     ...route('/archivos', Archivos, {
       Auth: true,
       //req_admin: true
    }),]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes